import SetData from "@/vuex/SetData";
import i18n from "@/i18n";

class MenuList {

    getVariationList(currentItem) {
        let set = SetData.getters.getSet;
        let variationList = {};

        if (typeof set.items === 'object' && typeof set.items[0].description.possibleVariations === 'object') {
            currentItem = (set.items.length === 1) ? 0 : currentItem;

            if (currentItem === 'overview' || currentItem === 'all' || currentItem === 'set') {
                variationList = JSON.parse(JSON.stringify(set.items[0].description.possibleVariations));

                if (set.items.length > 1) {
                    for (let i = 1; i < set.items.length; i++) {
                        if (Object.prototype.hasOwnProperty.call(set.items[i].description, 'possibleVariations')) {
                            for (let key in set.items[i].description.possibleVariations) {
                                if (Object.prototype.hasOwnProperty.call(set.items[i].description.possibleVariations, key)) {
                                    if (set.items[i].description.possibleVariations[key] === true) {
                                        variationList[key] = true;
                                    }
                                }
                            }
                        }
                    }
                }

                variationList['diamondExchange'] = false;
            } else if (typeof set.items[currentItem] === 'object') {
                variationList = set.items[currentItem].description.possibleVariations;
            }
        }

        return variationList;
    }

    getItemsByVarType(varType) {
        let set = SetData.getters.getSet;
        let items = [];

        if (varType === 'stones/library' || varType.substr(0, 13) === 'stones/group/' || varType === 'stones/jewellery/normal') {
            varType = 'stones';
        }

        for (let i = 0; i < set.items.length; i++) {
            if (Object.prototype.hasOwnProperty.call(set.items, i) &&
                Object.prototype.hasOwnProperty.call(set.items[i].description, 'possibleVariations')
            ) {
                set.items[i].description.possibleVariations = this.translateKeys(set.items[i].description.possibleVariations);

                let curVarType = varType

                if (curVarType === 'stones') {
                    if (set.items[i].description.possibleVariations.stones === false) {
                        curVarType = ((set.items[i].description.possibleVariations.jewelleryStone.normal) ? 'stones/jewellery/normal' : 'stones/jewellery/model');
                    }
                }

                if (set.items[i].description.possibleVariations &&
                    Object.prototype.hasOwnProperty.call(set.items[i].description.possibleVariations, curVarType) &&
                    set.items[i].description.possibleVariations[curVarType] === true) {
                    items.push(i);
                }
            }
        }

        return (items.length === set.items.length && this.allowOverallChanges(set, varType)) ? 'all' : items;
    }

    allowOverallChanges(set, varType) {
        return (set.summary.possibleVariations[varType] === true);
    }

    translateKeys(possibleVariations) {
        if (typeof possibleVariations == 'object') {
            possibleVariations['jewellery/model'] = possibleVariations.jewellery.model;
            possibleVariations['jewellery/necklace'] = possibleVariations.jewellery.necklace;
            possibleVariations['jewellery/setting'] = possibleVariations.jewellery.setting;

            possibleVariations['stones/jewellery/normal'] = possibleVariations.jewelleryStone.normal;
            possibleVariations['stones/jewellery/model'] = possibleVariations.jewelleryStone.model;

            possibleVariations['stones/diamondExchange'] = possibleVariations.diamondExchange;

            possibleVariations['stones/library'] = possibleVariations.stones;
        }

        return possibleVariations;
    }

    get(currentItem) {
        let list = {};

        let variationsList = this.getVariationList(currentItem);


        if (typeof variationsList === 'object') {
            const set = SetData.getters.getSet;

            if (typeof set.items[currentItem] === 'object' && set.items[currentItem].description.jewelleryType == 3) {
                if (variationsList.colors) {
                    list['colors'] = i18n.t('Menu.var.colors');
                }
                if (variationsList.metals) {
                    list['metals'] = i18n.t('Menu.var.metals');
                }
                if (variationsList.basicModel) {
                    list['basicModel'] = i18n.t('Menu.var.basicModel');
                }
                if (variationsList.stones) {
                    list['stones'] = i18n.t('Menu.var.stones');
                }
                if (typeof variationsList.jewellery != 'undefined' && variationsList.jewellery.model) {
                    list['jewellery/model'] = i18n.t('Menu.var.jewellery.basicModel');
                }
                if (typeof variationsList.jewellery != 'undefined' && variationsList.jewellery.necklace) {
                    list['jewellery/necklace'] = i18n.t('Menu.var.jewellery.necklace');
                }
                if (typeof variationsList.jewellery != 'undefined' && variationsList.jewellery.setting) {
                    list['jewellery/setting'] = i18n.t('Menu.var.jewellery.setting');
                }
                if (typeof variationsList.jewelleryStone === 'object' && variationsList.jewelleryStone.normal) {
                    list['stones/jewellery/normal'] = i18n.t('Menu.var.jewellery.normal');
                }
                if (typeof variationsList.jewelleryStone != 'undefined' && variationsList.jewelleryStone.model) {
                    list['stones/jewellery/model'] = i18n.t('Menu.var.jewellery.model');
                }
                if (variationsList.diamondExchange) {
                    list['stones/diamondExchange'] = i18n.t('Menu.var.diamondExchange');
                }
                if (variationsList.engraving) {
                    list['engraving'] = i18n.t('Menu.var.engraving');
                }
            } else {
                if (variationsList.profiles) {
                    list['profiles'] = i18n.t('Menu.var.profiles');
                }
                if (typeof variationsList.jewellery != 'undefined' && variationsList.jewellery.necklace) {
                    list['jewellery/necklace'] = i18n.t('Menu.var.jewellery.necklace');
                }
                if (variationsList.widths) {
                    list['widths'] = i18n.t('Menu.var.widths');
                }
                if (variationsList.lengths) {
                    list['lengths'] = i18n.t('Menu.var.lengths');
                }
                if (variationsList.chainWidths) {
                  list['chainWidths'] = i18n.t('Menu.var.chainWidths');
                }
                if (variationsList.allocations) {
                    list['allocations'] = i18n.t('Menu.var.allocations');
                }
                if (variationsList.colors) {
                    list['colors'] = i18n.t('Menu.var.colors');
                }
                if (variationsList.metals) {
                    list['metals'] = i18n.t('Menu.var.metals');
                }
                if (variationsList.finishes) {
                    list['finishes'] = i18n.t('Menu.var.finishes');
                }
                if (variationsList.grooves) {
                    list['grooves'] = i18n.t('Menu.var.grooves');
                }
                if (variationsList.addons) {
                    list['addons'] = i18n.t('Menu.var.addons');
                }
                if (variationsList.basicModel) {
                    list['basicModel'] = i18n.t('Menu.var.basicModel');
                }
                if (variationsList.stones && !variationsList.jewelleryStone.normal && !variationsList.jewelleryStone.model) {
                    list['stones'] = i18n.t('Menu.var.stones');
                }
                if (typeof variationsList.jewellery != 'undefined' && variationsList.jewellery.model) {
                    list['jewellery/model'] = i18n.t('Menu.var.jewellery.basicModel');
                }
                if (variationsList.shutters) {
                  list["shutters"] = i18n.t("Menu.var.shutters");
                }
                if (typeof variationsList.jewellery != 'undefined' && variationsList.jewellery.setting) {
                    list['jewellery/setting'] = i18n.t('Menu.var.jewellery.setting');
                }
                if (typeof variationsList.jewelleryStone === 'object' && variationsList.jewelleryStone.normal) {
                    list['stones/jewellery/normal'] = i18n.t('Menu.var.jewellery.normal');
                }
                if (typeof variationsList.jewelleryStone != 'undefined' && variationsList.jewelleryStone.model) {
                    list['stones/jewellery/model'] = i18n.t('Menu.var.jewellery.model');
                }
                if (variationsList.diamondExchange) {
                    list['stones/diamondExchange'] = i18n.t('Menu.var.diamondExchange');
                }
                if (variationsList.engraving) {
                    list['engraving'] = i18n.t('Menu.var.engraving');
                }
            }
        }
        return list;
    }
}

export default new MenuList();
